<div class="">
  <div class="row">
    <div class="col-md-12 text-left">
<!--      <h3 class="primary-color">{{editMode?'تعديل':'إضافة'}} خبر جديد</h3>-->
    </div>
  </div>
  <div class="row" >
    <div class="col-md-12">
      <form  [formGroup]="data">
        <div class="row">
          <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12  text-center">
            <img [src]="profileImg" style="width: 100%;height: 200px" (click)="openFile()"  alt="User Pic"  id="" class="  img-responsive">

            <input (change)="changeImage($event)" type="file" id="file"  style="display:none"/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <input type="text" formControlName="title" placeholder="عنوان الخبر" class="form-control">
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <textarea placeholder="نص الخبر" value="" formControlName="description" #textarea id="textarea" style="min-height:245px ">

            </textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button"  style="width:280px"  (click)="editMode?edit():add()" [disabled]="!data.valid" data-dismiss="modal"  class="btn radius-16  background-blue-g pr-5 pl-5" >
                {{editMode?"تعديل":"إضافة"}}


              </button>

            </div>
          </div>
        </div>


      </form>



    </div>
  </div>
</div>
